@if (showLoader) {
  <div class="render-loading-overlay">
    <div class="render-spinner"></div>
  </div>
}
<div class="bathroom-render">
  @if (renderItems.length > 0) {
    <div class="render-viewport" [ngStyle]="getViewportStyle()">
      @for (item of renderItems; track trackByItem($index, item)) {
        <div
          [class]="getItemClass(item)"
          [ngStyle]="getItemStyle(item)"
          (click)="onItemClick(item)"
          [attr.data-type]="item.type"
          [attr.data-row]="item.rowIndex"
          [attr.data-column]="item.columnIndex">
          <img [src]="item.imageUrl" [alt]="item.type" class="render-image" loading="lazy" />

          @if (isItemSelected(item)) {
            <div class="selection-overlay">
              <i class="fas fa-check"></i>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="render-empty">
      <i class="fas fa-cube"></i>
      <p>Aucun élément à afficher</p>
    </div>
  }
</div>
